export default __webpack_public_path__ + "static/driveways-fb29874c41a1e69bd85644b5d238463c.webp";